import { IMG } from "@/lib/site";

const R = (title, to, desc) => ({ title, to, desc });

export const pagesA = [
  {
    slug: "/winterdienst-bremen",
    title: "Winterdienst Bremen | Bremer Schneemann",
    description:
      "Professioneller Winterdienst in Bremen: Schneeräumung, Streudienst und Eisbeseitigung für Privat und Gewerbe. Persönlicher Ansprechpartner, Angebot auf Anfrage.",
    label: "/ Winterdienst Bremen",
    service: "Winterdienst Bremen",
    h1Lines: ["Winterdienst Bremen –", "zuverlässig geräumt,", "gestreut und gesichert."],
    intro:
      "Bremer Schneemann ist Ihr Winterdienst in Bremen und Umgebung. Wir räumen Schnee, streuen Salz oder Sand und beseitigen Eis – auf Gehwegen, Zufahrten, Parkplätzen und an Eingängen von privaten und gewerblichen Objekten.",
    image: IMG.heroStreet,
    sections: [
      {
        h2: "Professioneller Winterdienst für das gesamte Bremer Stadtgebiet",
        p: [
          "Winter in Bremen ist selten planbar. Mal bleibt der Schnee wochenlang aus, dann fällt innerhalb einer Nacht so viel, dass Gehwege, Hofzufahrten und Parkflächen am Morgen unpassierbar sind. Dazwischen liegt das, was in der norddeutschen Tiefebene am häufigsten vorkommt: Nässe, Nachtfrost und am frühen Morgen eine dünne, kaum sichtbare Eisschicht auf Pflaster, Beton und Asphalt. Genau diese Tage sind für Eigentümer, Hausverwaltungen und Betriebe die kritischsten.",
          "Bremer Schneemann ist auf diese Bremer Witterung eingestellt. Wir übernehmen den Winterdienst als wiederkehrende Leistung über die Saison oder für einzelne, kurzfristige Einsätze. Dabei arbeiten wir mit Schneeschiebern, Räumgeräten und Streumitteln, die zur jeweiligen Fläche passen – ein Kopfsteinpflaster vor einem Altbau in der Östlichen Vorstadt braucht eine andere Behandlung als ein Betriebshof in Sebaldsbrück oder eine Tiefgaragenrampe in der Vahr.",
          "Als regionaler Dienstleister mit Sitz an der Flughafenallee sind wir im Stadtgebiet schnell vor Ort. Sie sprechen dabei immer mit derselben Person: Inhaber Adil Altun koordiniert die Einsätze selbst und kennt Ihr Objekt nach dem ersten Termin.",
        ],
      },
      {
        h2: "Das Problem: Räum- und Streupflicht trifft Sie persönlich",
        p: [
          "In Bremen sind Anlieger verpflichtet, Gehwege entlang ihres Grundstücks von Schnee zu befreien und bei Glätte zu streuen. Diese Pflicht endet nicht, wenn Sie im Urlaub, auf Montage, im Schichtdienst oder einfach beruflich gebunden sind. Wer sie nicht erfüllt, riskiert Bußgelder und – deutlich unangenehmer – Haftungsansprüche, wenn jemand auf der Fläche stürzt.",
          "Für Unternehmen kommt eine zweite Dimension hinzu: Mitarbeitende, Kunden und Lieferverkehr müssen das Gelände sicher erreichen. Ein nicht geräumter Parkplatz oder eine glatte Laderampe bedeutet nicht nur Unfallgefahr, sondern auch Betriebsstörung – Anlieferungen verschieben sich, Termine fallen aus.",
        ],
      },
      {
        h2: "Die Lösung: ein fester Winterdienst für Ihre Flächen",
        p: [
          "Wir übernehmen die Verkehrssicherung auf Ihren Flächen und dokumentieren, was wann gemacht wurde. Grundlage ist ein kurzer Vorab-Termin oder eine Beschreibung Ihrer Fläche: Welche Wege sind zu räumen? Wo liegen Eingänge, Treppen und Zufahrten? Wohin kann der Schnee gelagert werden? Gibt es Zeitfenster, in denen nicht gearbeitet werden darf?",
          "Aus diesen Informationen entsteht ein klarer Räumplan. Sie wissen, welche Flächen in welchem Umfang betreut werden, und wir wissen, worauf es an Ihrem Objekt ankommt. Preise nennen wir immer objektbezogen – ein Angebot auf Anfrage statt einer Pauschale, die am Ende nicht passt.",
        ],
        bullets: [
          "Schneeräumung von Gehwegen und Zufahrten",
          "Streuen von Salz oder Sand auf Wegen und Fahrflächen",
          "Eisbeseitigung an Treppen und Eingangsbereichen",
          "Räumung von Parkplätzen, Parkdecks und Parkhäusern",
          "Entfernung von Schneemassen vor Einfahrten und Garagen",
          "24/7-Bereitschaftsdienst bei Schneefall",
          "Winterdienst für private und gewerbliche Objekte",
        ],
      },
      {
        h2: "Warum Bremer Schneemann",
        p: [
          "Wir sind kein überregionaler Subunternehmer-Pool, sondern ein Bremer Betrieb mit einem festen Ansprechpartner. Das heißt: kurze Wege, klare Absprachen und keine Warteschleife, wenn es morgens um fünf schneit.",
        ],
        bullets: [
          "Persönlicher Ansprechpartner – Inhaber Adil Altun",
          "Bremen und das direkte Umland als Einsatzgebiet",
          "Private und gewerbliche Objekte aus einer Hand",
          "Winterdienst nach Bedarf oder als Saisonbetreuung",
          "Streumittel passend zur Fläche – nicht pauschal Salz",
        ],
      },
    ],
    steps: [
      { t: "Anfrage", d: "Sie rufen an, schreiben per WhatsApp oder mailen uns Adresse und Fläche." },
      { t: "Objektaufnahme", d: "Wir klären Flächengröße, Beläge, Zugänge, Schneelager und Zeitfenster." },
      { t: "Angebot", d: "Sie erhalten ein objektbezogenes Angebot – als Einzeleinsatz oder für die Saison." },
      { t: "Einsatz", d: "Bei Schneefall und Glätte räumen und streuen wir die vereinbarten Flächen." },
      { t: "Rückmeldung", d: "Sie wissen, was gemacht wurde – auf Wunsch mit kurzer Einsatzdokumentation." },
    ],
    objects: [
      "Einfamilien- und Reihenhäuser",
      "Mehrfamilienhäuser und Wohnanlagen",
      "Bürogebäude und Praxen",
      "Betriebshöfe und Gewerbeobjekte",
      "Kundenparkplätze und Parkdecks",
      "Hausverwaltungen und Eigentümergemeinschaften",
    ],
    local:
      "Unser Schwerpunkt ist das Bremer Stadtgebiet – von Mitte, Neustadt und Findorff über Schwachhausen, Horn-Lehe und Oberneuland bis Hemelingen, Sebaldsbrück, Vahr, Osterholz, Walle, Gröpelingen, Burglesum und Vegesack. Durch den Firmensitz an der Flughafenallee erreichen wir den Osten Bremens besonders schnell, fahren aber das gesamte Stadtgebiet und das direkte Umland an.",
    faq: [
      { q: "Was umfasst Ihr Winterdienst in Bremen?", a: "Schneeräumung von Gehwegen, Zufahrten, Höfen und Parkflächen, das Streuen von Salz oder Sand sowie die Beseitigung von Eis an Treppen und Eingangsbereichen. Auf Wunsch auch das Abtransportieren größerer Schneemengen." },
      { q: "Arbeiten Sie für Privatkunden und Gewerbe?", a: "Ja. Wir betreuen Einfamilienhäuser und Wohnanlagen genauso wie Betriebsgelände, Parkplätze und Gewerbeimmobilien." },
      { q: "Kann ich den Winterdienst auch nur für einzelne Einsätze buchen?", a: "Ja. Neben der Saisonbetreuung sind Einzeleinsätze möglich, zum Beispiel nach starkem Schneefall oder während einer Abwesenheit." },
      { q: "Was kostet der Winterdienst?", a: "Das hängt von Fläche, Umfang und Erreichbarkeit ab. Wir erstellen Ihnen ein Angebot auf Anfrage – ohne pauschale Listenpreise." },
      { q: "Wie schnell können Sie starten?", a: "Nach einer kurzen Objektaufnahme können wir den Winterdienst in der laufenden Saison aufnehmen. Rufen Sie an oder schreiben Sie per WhatsApp, dann klären wir das direkt." },
    ],
    related: [
      R("Schneeräumung Bremen", "/schneeraeumung-bremen", "Räumen von Wegen, Höfen und Flächen."),
      R("Streudienst Bremen", "/streudienst-bremen", "Salz und abstumpfende Streumittel."),
      R("Winterdienst Privat", "/winterdienst-bremen-privat", "Für Haus, Hof und Gehweg."),
      R("Winterdienst Gewerbe", "/winterdienst-bremen-gewerbe-hausverwaltung", "Für Unternehmen und Immobilien."),
      R("Eisbeseitigung Bremen", "/eisbeseitigung-bremen", "Glätte an Treppen und Eingängen."),
      R("Einsatzgebiet", "/einsatzgebiet", "Bremen und die Stadtteile im Überblick."),
    ],
  },

  {
    slug: "/winterdienst-bremen-privat",
    title: "Winterdienst Bremen für Privatkunden | Schnee räumen lassen",
    description:
      "Winterdienst in Bremen für Privatkunden: Schneeräumung für Gehweg und Einfahrt, Streudienst und Eisbeseitigung für Hauseigentümer. Schnee räumen lassen – Angebot auf Anfrage.",
    label: "/ Winterdienst Privatkunden",
    service: "Winterdienst Bremen für Privatkunden",
    landing: true,
    formType: "Privatkunde",
    audienceLabel: "/ Für wen diese Seite ist",
    audienceTitle: "Privater Winterdienst für Hauseigentümer in Bremen",
    audience: [
      "Hauseigentümerinnen und Hauseigentümer",
      "Privatpersonen ohne eigenes Räumgerät",
      "Einfamilien-, Reihen- und Doppelhäuser",
      "Eigentümer von Mehrfamilienhäusern",
      "Private Vermieterinnen und Vermieter",
      "Haushalte mit eingeschränkter Mobilität",
    ],
    ctaPrimary: "Winterdienst für mein Grundstück anfragen",
    ctaSecondary: "Jetzt Angebot für Winter 2026/2027 erhalten",
    h1Lines: ["Winterdienst Bremen", "für Privatkunden –", "Gehweg & Einfahrt frei."],
    intro:
      "Sie möchten Ihren Gehweg, die Einfahrt und den Hauseingang im Winter nicht selbst räumen? Bremer Schneemann übernimmt Schneeräumung, Streudienst und Eisbeseitigung für Privathaushalte in Bremen und Umgebung – mit festem Ansprechpartner und individuell abgestimmtem Umfang.",
    image: IMG.clearedWalk,
    sections: [
      {
        h2: "Schnee räumen lassen statt jeden Morgen selbst schippen",
        p: [
          "Der Gehweg vor dem eigenen Haus ist der Klassiker: Er muss früh geräumt sein, weil Schulkinder, Berufstätige und Postboten darauf unterwegs sind – und zwar bevor der Berufsverkehr beginnt. Für Berufstätige im Frühdienst, für Familien mit vollem Morgenprogramm und für Eigentümer, die nicht mehr selbst schippen möchten oder können, ist das eine echte Belastung.",
          "Wir übernehmen das für Sie. Bei Schneefall räumen wir den Gehweg entlang Ihres Grundstücks, legen den Weg zur Haustür frei, machen die Einfahrt befahrbar und streuen dort, wo Glätte entsteht. Bei überfrierender Nässe – in Bremen der häufigere Fall – liegt der Fokus auf dem Streudienst und auf den gefährlichen Punkten: Stufen, Rampen, Schwellen und die Kante zwischen Gehweg und Fahrbahn.",
        ],
      },
      {
        h2: "Das Problem: Ihre Räum- und Streupflicht bleibt – auch wenn Sie nicht da sind",
        p: [
          "Als Anlieger in Bremen sind Sie für den Gehweg an Ihrem Grundstück verantwortlich. Urlaub, Krankheit, Schichtdienst oder eine Dienstreise ändern daran nichts. Stürzt jemand auf einer nicht geräumten Fläche, kann das zu Schadensersatzforderungen führen – und die wenigsten Haushalte wollen diesen Fall erst dann durchdenken.",
          "Auch praktisch ist das Thema unangenehm: Wer kein geeignetes Gerät und keinen Platz für Streugut hat, räumt mit dem falschen Werkzeug, verdichtet Schnee zu Eis oder streut Salz dort, wo es Pflaster und Pflanzen schadet.",
        ],
      },
      {
        h2: "Die Lösung: fester Winterdienst für Ihr Zuhause",
        p: [
          "Wir nehmen Ihr Grundstück einmal auf und wissen danach genau, was zu tun ist: wie breit der Gehweg geräumt wird, wo der Schnee gelagert werden darf, ob Treppenstufen zum Eingang gehören und ob die Garagenzufahrt mit erfasst wird. Danach läuft der Winterdienst ohne Rückfragen.",
        ],
        bullets: [
          "Gehwege entlang des Grundstücks räumen und streuen",
          "Weg zur Haustür und Eingangsbereich freihalten",
          "Einfahrten und Garagenzufahrten befahrbar machen",
          "Treppenstufen und Podeste von Eis befreien",
          "Streumittel passend zum Belag – Pflaster, Beton, Asphalt",
          "Einzeleinsätze bei Urlaub oder Abwesenheit",
        ],
      },
      {
        h2: "Für welche privaten Objekte wir arbeiten",
        p: [
          "Von der kleinen Reihenhauszeile bis zum Grundstück mit langer Zufahrt: Wir betreuen Privatobjekte in ganz Bremen. Auch Eigentümergemeinschaften und kleinere Wohnanlagen fragen uns regelmäßig an, wenn die Flächen zu groß geworden sind, um sie in Eigenleistung zu halten.",
        ],
      },
      {
        h2: "Warum sich die professionelle Beauftragung lohnt",
        p: [
          "Wer die Gehwegreinigung im Winter abgibt, gewinnt vor allem Verlässlichkeit: Die Flächen sind auch dann geräumt, wenn Sie im Urlaub, im Frühdienst oder krank sind. Dazu kommt die richtige Technik – vom Räumgerät bis zum passenden Streugut – und die Erfahrung, an welchen Stellen Glätte zuerst entsteht.",
          "Sie müssen kein Streugut lagern, kein Gerät warten und sich morgens nicht um das Zeitfenster kümmern. Die Anfrage ist unverbindlich: Wir schauen uns Ihr Grundstück an und machen Ihnen ein Angebot, das zu Flächengröße und Umfang passt.",
        ],
        bullets: [
          "Keine eigene Technik und kein Streugutlager nötig",
          "Zuverlässig auch bei Urlaub, Krankheit oder Schichtdienst",
          "Passendes Streumittel für Pflaster, Beton und Asphalt",
          "Fester Ansprechpartner statt wechselnder Dienstleister",
          "Umfang frei wählbar – vom Gehweg bis zum Komplettpaket",
          "Unverbindliche Anfrage und objektbezogenes Angebot",
        ],
      },
      {
        h2: "Winterdienst in Bremen und Umgebung – so läuft die Anfrage",
        p: [
          "Melden Sie sich per Formular, Telefon oder WhatsApp mit Adresse und einer kurzen Beschreibung der Flächen. Wir nehmen das Objekt auf, halten den Umfang schriftlich fest und senden Ihnen ein Angebot für die Saison 2026/2027 oder für einzelne Einsätze. Erst mit Ihrer Zusage wird daraus eine Beauftragung.",
        ],
      },
    ],
    steps: [
      { t: "Kontakt", d: "Anruf oder WhatsApp mit Adresse und kurzer Beschreibung der Flächen." },
      { t: "Vor Ort", d: "Wir schauen uns Gehweg, Eingang und Einfahrt an – meist in wenigen Minuten." },
      { t: "Angebot", d: "Sie erhalten ein Angebot für die Saison oder für Einzeleinsätze." },
      { t: "Winterdienst", d: "Bei Schnee und Glätte sind Ihre Flächen frei – ohne dass Sie etwas tun müssen." },
    ],
    objects: [
      "Einfamilienhäuser",
      "Reihen- und Doppelhäuser",
      "Grundstücke mit langer Zufahrt",
      "Kleine Wohnanlagen und WEG",
      "Ferien- und Zweitwohnungen",
      "Haushalte mit eingeschränkter Mobilität",
    ],
    local:
      "Wir sind in den Bremer Wohnquartieren unterwegs – in Schwachhausen, Findorff, Horn-Lehe, Oberneuland, Borgfeld, Hemelingen, Sebaldsbrück, Obervieland, Huchting, Burglesum und Vegesack. Je nach Lage lassen sich Touren bündeln, was gerade für Nachbarschaften interessant ist, die sich gemeinsam melden.",
    faq: [
      { q: "Räumen Sie auch nur den Gehweg?", a: "Ja. Sie können den Umfang festlegen – nur Gehweg, Gehweg plus Eingang oder zusätzlich Einfahrt und Garagenzufahrt." },
      { q: "Kann ich den Winterdienst nur für meinen Urlaub buchen?", a: "Ja, zeitlich begrenzte Einsätze sind möglich. Geben Sie uns den Zeitraum und die Flächen, dann machen wir ein Angebot." },
      { q: "Welches Streumittel verwenden Sie?", a: "Je nach Fläche Salz oder abstumpfende Mittel wie Sand oder Granulat. Auf empfindlichen Belägen und in der Nähe von Bepflanzung arbeiten wir bevorzugt abstumpfend." },
      { q: "Bis wann sind die Flächen morgens geräumt?", a: "Wir richten die Touren so ein, dass die Flächen zum morgendlichen Berufsverkehr begehbar sind. Das konkrete Zeitfenster klären wir bei der Objektaufnahme." },
      { q: "Was kostet privater Winterdienst in Bremen?", a: "Das richtet sich nach Flächengröße, Umfang und Lage. Sie erhalten ein Angebot auf Anfrage." },
      { q: "Arbeiten Sie auch außerhalb von Bremen?", a: "Ja, wir sind in Bremen und in den direkt angrenzenden Nachbarstädten im Umland tätig. Ob Ihr Objekt im Einsatzgebiet liegt, klären wir kurz bei der Anfrage." },
      { q: "Ist die Anfrage über das Formular verbindlich?", a: "Nein. Die Anfrage ist unverbindlich und kostenfrei. Sie erhalten zunächst ein Angebot – ein Vertrag entsteht erst, wenn Sie zustimmen." },
    ],
    related: [
      R("Gehweg-Winterdienst", "/gehweg-winterdienst-bremen", "Räum- und Streupflicht am Gehweg."),
      R("Zufahrten räumen", "/zufahrten-winterdienst-bremen", "Einfahrt und Hofzufahrt frei halten."),
      R("Garagen & Einfahrten", "/garagen-winterdienst-bremen", "Schneemassen vor dem Tor entfernen."),
      R("Treppen & Eingänge", "/treppen-winterdienst-bremen", "Die kritischsten Punkte am Haus."),
      R("Gewerbe & Hausverwaltung", "/winterdienst-bremen-gewerbe-hausverwaltung", "Für Firmen, Verwaltungen und Wohnanlagen."),
      R("Winterdienst Bremen", "/winterdienst-bremen", "Alle Leistungen im Überblick."),
    ],
  },

  {
    slug: "/winterdienst-bremen-gewerbe-hausverwaltung",
    title: "Winterdienst Bremen: Gewerbe & Hausverwaltungen",
    description:
      "Gewerblicher Winterdienst in Bremen für Firmen, Hausverwaltungen und Immobilienverwaltungen: Parkplätze, Zufahrten, Gehwege und Außenflächen räumen und streuen. Angebot auf Anfrage.",
    label: "/ Gewerbe & Hausverwaltung",
    service: "Winterdienst Bremen Gewerbe und Hausverwaltung",
    landing: true,
    formType: "Gewerbekunde",
    audienceLabel: "/ Für wen diese Seite ist",
    audienceTitle: "Winterdienst für Hausverwaltungen, Gewerbe und Wohnanlagen",
    audience: [
      "Hausverwaltungen und Immobilienverwaltungen",
      "Eigentümergemeinschaften (WEG)",
      "Vermieter von Mehrfamilienhäusern",
      "Gewerbeunternehmen und Industriebetriebe",
      "Büro- und Geschäftshäuser",
      "Unternehmen mit großen Außenflächen",
    ],
    ctaPrimary: "Gewerbliches Winterdienst-Angebot anfordern",
    ctaSecondary: "Angebot für Hausverwaltung anfragen",
    h1Lines: ["Winterdienst Bremen für", "Gewerbe & Hausverwaltungen –", "Flächen sicher im Betrieb."],
    intro:
      "Wenn im Winter der Betrieb nicht stillstehen darf: Bremer Schneemann räumt und streut Parkplätze, Zufahrten, Gehwege und Außenflächen von Gewerbeobjekten, Wohnanlagen und verwalteten Immobilien in Bremen – mit festen Absprachen, planbaren Abläufen und einem Ansprechpartner, der Ihr Objekt kennt.",
    image: IMG.parkingLot,
    sections: [
      {
        h2: "Winterdienst für Unternehmen: Verkehrssicherheit ist Betriebssicherheit",
        p: [
          "Für Gewerbebetriebe ist Winterdienst keine Komfortfrage, sondern Teil der Betriebsorganisation. Mitarbeitende müssen morgens den Parkplatz erreichen, Lieferverkehr muss an die Rampe kommen, Kunden müssen den Eingang sicher betreten. Jede nicht geräumte Fläche ist ein potenzieller Unfallort – und jeder Unfall auf dem Gelände ist ein Thema für Versicherung, Dokumentation und Haftung.",
          "Wir planen den Winterdienst deshalb entlang Ihrer Betriebsabläufe. Entscheidend ist nicht nur die Quadratmeterzahl, sondern die Reihenfolge: Welche Fläche muss zuerst frei sein? Ab wann kommt der erste Lkw? Wo darf geräumter Schnee liegen, ohne Stellplätze oder Fluchtwege zu blockieren? Diese Fragen klären wir vor der Saison, nicht in der Nacht des ersten Schneefalls.",
        ],
      },
      {
        h2: "Das Problem: große Flächen, enge Zeitfenster, klare Haftung",
        p: [
          "Gewerbeflächen sind im Winter aus drei Gründen anspruchsvoll. Erstens die Größe: Ein Kundenparkplatz oder Betriebshof lässt sich nicht von Hand räumen. Zweitens das Zeitfenster: Zwischen letztem Schneefall und Schichtbeginn liegen oft nur wenige Stunden. Drittens die Verantwortung: Als Eigentümer, Mieter oder Verwalter tragen Sie die Verkehrssicherungspflicht für das Gelände.",
          "Hinzu kommt die Logistik des Schnees selbst. Wer auf einem vollen Parkplatz räumt, ohne vorher festgelegt zu haben, wohin der Schnee geschoben wird, verliert Stellplätze oder blockiert Zufahrten. Große Schneemengen müssen zudem teilweise abtransportiert werden.",
        ],
      },
      {
        h2: "Die Lösung: abgestimmter Räum- und Streuplan für Ihr Objekt",
        p: [
          "Wir erstellen gemeinsam mit Ihnen einen Plan, der Prioritäten, Zeitfenster und Schneelagerflächen festhält. Auf dieser Basis arbeiten wir maschinell auf den großen Flächen und von Hand an den Punkten, die Technik nicht erreicht – Treppen, Eingänge, Fluchttüren, Fahrradabstellplätze, Müllplatz.",
        ],
        bullets: [
          "Parkplätze, Parkdecks und Parkhäuser räumen und streuen",
          "Betriebshöfe, Zufahrten und Rampen freihalten",
          "Gehwege entlang des Betriebsgrundstücks übernehmen",
          "Eingänge, Treppen und Fluchtwege von Eis befreien",
          "Schneelagerung nach Plan – ohne Stellplätze zu blockieren",
          "Abtransport größerer Schneemengen auf Absprache",
          "Bereitschaftsdienst bei Schneefall, auch nachts",
        ],
      },
      {
        h2: "Winterdienst für Hausverwaltungen und Immobilienverwaltungen",
        p: [
          "Für Hausverwaltungen zählt vor allem eines: Der Winterdienst muss ohne ständige Rücksprache laufen und im Zweifel belegbar sein. Wir betreuen Wohnanlagen und Mehrfamilienhäuser im Auftrag von Verwaltungen und Eigentümergemeinschaften – von den Gehwegen entlang des Grundstücks über Hofflächen und Stellplätze bis zu Hauseingängen, Treppen und Müllplätzen.",
          "Auf Wunsch erstellen wir ein Angebot für mehrere Objekte gemeinsam. Je Objekt halten wir fest, welche Flächen enthalten sind, in welcher Reihenfolge geräumt wird und wohin der Schnee geschoben werden darf. So haben Verwaltung, Eigentümer und Mieter dieselbe Informationsgrundlage.",
        ],
        bullets: [
          "Objektbezogene Leistungsbeschreibung je Wohnanlage",
          "Angebote für einzelne Objekte oder ganze Bestände",
          "Gehwege, Hofflächen, Stellplätze und Zuwege",
          "Hauseingänge, Treppen, Müll- und Fahrradplätze",
          "Saisonale Einsatzplanung vor Winterbeginn",
          "Einsatzdokumentation auf Wunsch je Termin",
        ],
      },
      {
        h2: "Vertragsmodelle und saisonale Einsatzplanung",
        p: [
          "Welche Form sinnvoll ist, hängt vom Objekt ab. Möglich sind ein Saisonvertrag für den Winter 2026/2027, ein laufender Winterdienstvertrag über mehrere Saisons, einzelne Einsätze nach Bedarf oder eine individuelle Vereinbarung für mehrere Immobilien. Was wir anbieten, halten wir im Angebot konkret fest – inklusive der Flächen, die enthalten sind.",
          "Die Planung findet vor der Saison statt: Prioritäten, Zeitfenster, Zugänge, Schlüsselübergabe und Schneelagerflächen werden abgestimmt, solange noch kein Schnee liegt. Eine Anfrage über das Formular ist unverbindlich und noch kein Vertragsabschluss.",
        ],
      },
      {
        h2: "Erfahrung mit gewerblichen Auftraggebern",
        p: [
          "Wir arbeiten regelmäßig für gewerbliche Auftraggeber und führen Dienstleistungen auch im Auftrag anderer Unternehmen aus – unter anderem als Subunternehmer für die Deutsche Bahn. Das bedeutet: abgestimmte Abläufe, Einsätze zu festen Zeitfenstern und eine saubere Dokumentation der ausgeführten Leistungen.",
          "Diese Tätigkeit ist eine Auftragsbeziehung als Subunternehmer und keine offizielle Partnerschaft, Zertifizierung oder Empfehlung durch den Auftraggeber.",
        ],
      },
      {
        h2: "Dokumentation und Ansprechbarkeit",
        p: [
          "Für gewerbliche Auftraggeber ist nicht nur wichtig, dass geräumt wurde, sondern dass es nachvollziehbar ist. Auf Wunsch dokumentieren wir die Einsätze mit Datum, Uhrzeit und Leistung – hilfreich bei Rückfragen von Versicherungen, Mietern oder der Geschäftsführung.",
          "Ansprechpartner bleibt Inhaber Adil Altun. Sie telefonieren nicht mit einer Zentrale, sondern direkt mit der Person, die den Einsatz plant.",
        ],
      },
    ],
    steps: [
      { t: "Erstgespräch", d: "Wir klären Objektart, Flächen, Zeitfenster und Prioritäten." },
      { t: "Begehung", d: "Vor-Ort-Termin: Beläge, Engstellen, Schneelager, Zugänge, Schlüssel/Zufahrt." },
      { t: "Räumplan & Angebot", d: "Sie erhalten Leistungsumfang und Angebot für die Saison." },
      { t: "Saisonbetrieb", d: "Bereitschaft, Einsatz bei Schnee und Glätte, Nacharbeit bei Bedarf." },
      { t: "Dokumentation", d: "Einsatznachweise auf Wunsch – für Verwaltung und Versicherung." },
    ],
    objects: [
      "Kunden- und Mitarbeiterparkplätze",
      "Betriebshöfe und Logistikflächen",
      "Büro- und Verwaltungsgebäude",
      "Handels- und Ladenflächen",
      "Industrie- und Gewerbeobjekte",
      "Arztpraxen, Kanzleien, Dienstleister",
      "Hausverwaltungen und Facility-Dienstleister",
    ],
    local:
      "Die Bremer Gewerbelagen sind unser Alltag: die Betriebsgebiete in Hemelingen und Sebaldsbrück, die Flächen in Hastedt und an der Weser, die Gewerbegebiete in Walle, Gröpelingen und Bremen-Nord sowie die Bürostandorte in Mitte, Überseestadt und Schwachhausen. Durch unseren Firmensitz an der Flughafenallee sind wir im Osten besonders schnell einsatzfähig.",
    faq: [
      { q: "Übernehmen Sie auch große Parkflächen?", a: "Ja. Parkplätze, Parkdecks und Parkhäuser gehören zu unseren Leistungen. Wichtig ist eine vorab festgelegte Fläche für die Schneelagerung." },
      { q: "Können Einsätze nachts oder vor Schichtbeginn erfolgen?", a: "Ja. Wir richten Zeitfenster so ein, dass die Flächen zum Arbeitsbeginn nutzbar sind. Die konkrete Taktung wird im Räumplan festgehalten." },
      { q: "Erhalten wir einen Nachweis über die Einsätze?", a: "Auf Wunsch dokumentieren wir Datum, Uhrzeit und ausgeführte Leistung je Einsatz." },
      { q: "Arbeiten Sie auch für Hausverwaltungen?", a: "Ja. Wir betreuen Objekte im Auftrag von Verwaltungen und Eigentümergemeinschaften." },
      { q: "Wie wird abgerechnet?", a: "Je nach Vereinbarung als Saisonleistung oder nach Einsatz. Die Grundlage ist immer ein objektbezogenes Angebot auf Anfrage." },
      { q: "Können Sie mehrere Objekte gleichzeitig betreuen?", a: "Ja. Für Verwaltungen und Eigentümer mit mehreren Immobilien erstellen wir ein gemeinsames Angebot mit einer Leistungsbeschreibung je Objekt." },
      { q: "Gibt es einen Winterdienstvertrag für die Saison?", a: "Möglich sind ein Saisonvertrag für 2026/2027, ein laufender Vertrag über mehrere Saisons, Einzeleinsätze oder eine individuelle Vereinbarung. Der konkrete Umfang wird im Angebot festgehalten." },
      { q: "Übernehmen Sie auch Gehwege vor Mehrfamilienhäusern?", a: "Ja. Gehwege entlang des Grundstücks, Zuwege, Hauseingänge und Treppen gehören zu den typischen Flächen, die wir für Wohnanlagen betreuen." },
    ],
    related: [
      R("Parkplatz-Winterdienst", "/parkplatz-winterdienst-bremen", "Parkflächen und Parkhäuser."),
      R("Gewerbeimmobilien", "/winterdienst-gewerbeimmobilien", "Büro, Industrie, Handel."),
      R("Winterdienst Immobilien", "/winterdienst-immobilien-bremen", "Wohnanlagen und Bestände."),
      R("24/7-Bereitschaft", "/winterdienst-24-7-bremen", "Einsatzbereit bei Schneefall."),
      R("Privatkunden", "/winterdienst-bremen-privat", "Für Hauseigentümer und Vermieter."),
      R("Winterdienst Bremen", "/winterdienst-bremen", "Leistungsübersicht."),
    ],
  },

  {
    slug: "/schneeraeumung-bremen",
    title: "Schneeräumung Bremen | Professioneller Schneeräumdienst",
    description:
      "Schneeräumung in Bremen: Schnee räumen auf Gehwegen, Höfen, Zufahrten und Parkflächen. Professioneller Schneeräumdienst für Privat und Gewerbe – Angebot auf Anfrage.",
    label: "/ Schneeräumung",
    service: "Schneeräumung Bremen",
    h1Lines: ["Schneeräumung Bremen –", "Flächen frei, bevor", "der Tag beginnt."],
    intro:
      "Schnee muss weg, bevor er festgefahren und zu Eis wird. Bremer Schneemann räumt Gehwege, Höfe, Zufahrten, Stellplätze und Parkflächen im Bremer Stadtgebiet – maschinell auf großen Flächen, von Hand dort, wo Präzision gebraucht wird.",
    image: IMG.shovelWorker,
    sections: [
      {
        h2: "Schnee entfernen, solange er noch locker liegt",
        p: [
          "Der entscheidende Faktor bei der Schneeräumung ist der Zeitpunkt. Frisch gefallener Schnee lässt sich schnell und vollständig entfernen. Wird er erst befahren oder betreten, verdichtet er sich zu einer harten Schicht, die anfriert und sich nur noch mit erheblichem Aufwand – und mehr Streumittel – lösen lässt. Deshalb planen wir Einsätze so, dass geräumt wird, bevor Betrieb auf der Fläche ist.",
          "Technisch arbeiten wir flächengerecht: Auf Parkplätzen, Höfen und langen Zufahrten kommt maschinelle Räumtechnik zum Einsatz, auf Gehwegen, Treppen, zwischen Pollern und an Engstellen räumen wir von Hand. Besonders bei Kopfsteinpflaster und altem Klinkerbelag, wie er in vielen Bremer Quartieren liegt, ist die Handarbeit nicht ersetzbar – ein hart geführter Schieber beschädigt sonst Fugen und Kanten.",
        ],
      },
      {
        h2: "Das Problem: Schnee wird oft nur verschoben, nicht gelöst",
        p: [
          "Ein häufiger Fehler ist die Schneelagerung. Wer Schnee einfach zur Seite schiebt, blockiert damit Stellplätze, Einfahrten, Gullys oder Fluchtwege. Taut die Schicht an und friert nachts wieder zu, entsteht genau dort eine Eisplatte, wo vorher nur Schnee lag.",
          "Das zweite Problem ist die Teilräumung: Ein Gehweg, der nur in der Mitte auf Schuhbreite freigeschaufelt wurde, erfüllt die Räumpflicht in der Regel nicht und bringt im Zweifel keine Sicherheit.",
        ],
      },
      {
        h2: "Die Lösung: vollständige Räumung mit definierter Schneelagerung",
        p: [
          "Wir legen vor der Saison fest, wohin der Schnee geht. Entwässerungspunkte bleiben frei, Fluchtwege bleiben nutzbar, Stellplätze werden nicht verbaut. Bei großen Mengen organisieren wir auf Absprache den Abtransport.",
        ],
        bullets: [
          "Gehwege auf nutzbarer Breite räumen – nicht nur eine Spur",
          "Zufahrten und Höfe durchgängig befahrbar halten",
          "Parkplätze und Stellplatzreihen räumen",
          "Schneemassen vor Garagen und Toren entfernen",
          "Schneelagerung nach vorab festgelegtem Plan",
          "Abtransport größerer Mengen auf Absprache",
          "Nachräumen bei anhaltendem Schneefall",
        ],
      },
      {
        h2: "Schneeräumung und Streudienst gehören zusammen",
        p: [
          "Nach dem Räumen bleibt in der Praxis immer eine dünne Restschicht oder Restfeuchte zurück. Fällt die Temperatur, wird daraus Glätte. Deshalb verbinden wir die Schneeräumung mit dem Streudienst: erst räumen, dann die kritischen Bereiche abstreuen. Das sind vor allem Stufen, Rampen, Kurven, Gefällestrecken und die Übergänge zwischen Gehweg und Fahrbahn.",
        ],
      },
    ],
    steps: [
      { t: "Flächen erfassen", d: "Größe, Belag, Engstellen und Zugänge werden aufgenommen." },
      { t: "Schneelager festlegen", d: "Wir bestimmen gemeinsam, wohin geräumter Schnee darf." },
      { t: "Räumen", d: "Maschinell auf Flächen, von Hand an Treppen, Kanten und Engstellen." },
      { t: "Abstreuen", d: "Restnässe und Glättestellen werden gezielt behandelt." },
    ],
    objects: [
      "Gehwege und Hauszugänge",
      "Innenhöfe und Hofzufahrten",
      "Einfahrten und Garagenvorplätze",
      "Kunden- und Mitarbeiterparkplätze",
      "Betriebshöfe und Logistikflächen",
      "Treppenanlagen und Podeste",
    ],
    local:
      "Gerade in den dicht bebauten Bremer Quartieren mit Altbaubestand und schmalen Gehwegen kommt es auf sorgfältige Handarbeit an. In Gewerbegebieten wie Hemelingen, Sebaldsbrück oder Walle stehen dagegen Flächenleistung und kurze Zeitfenster im Vordergrund. Wir bedienen beides im Bremer Stadtgebiet und im direkten Umland.",
    faq: [
      { q: "Wie schnell nach Schneefall wird geräumt?", a: "Wir planen Einsätze so, dass Flächen zu den vereinbarten Zeitfenstern nutzbar sind, in der Regel vor dem morgendlichen Berufsverkehr. Bei anhaltendem Schneefall räumen wir nach." },
      { q: "Räumen Sie auch Kopfsteinpflaster?", a: "Ja, hier arbeiten wir bewusst vorsichtig und überwiegend von Hand, damit Fugen und Kanten nicht beschädigt werden." },
      { q: "Wohin kommt der geräumte Schnee?", a: "Auf eine vorab festgelegte Lagerfläche, die keine Stellplätze, Gullys oder Fluchtwege blockiert. Bei großen Mengen ist Abtransport möglich." },
      { q: "Ist Streuen in der Schneeräumung enthalten?", a: "Wir empfehlen die Kombination und stimmen den Umfang im Angebot ab – räumen allein reicht bei Restnässe und Frost meist nicht." },
      { q: "Räumen Sie auch einmalig nach starkem Schneefall?", a: "Ja. Einzeleinsätze sind nach Verfügbarkeit möglich." },
    ],
    related: [
      R("Gehweg-Winterdienst", "/gehweg-winterdienst-bremen", "Gehwege räumen und streuen."),
      R("Zufahrten", "/zufahrten-winterdienst-bremen", "Einfahrten und Rampen."),
      R("Parkplätze", "/parkplatz-winterdienst-bremen", "Große Flächen und Parkdecks."),
      R("Streudienst Bremen", "/streudienst-bremen", "Nach dem Räumen abstreuen."),
      R("Garagen & Einfahrten", "/garagen-winterdienst-bremen", "Schneemassen vor Toren."),
      R("24/7-Bereitschaft", "/winterdienst-24-7-bremen", "Einsatz bei Dauerschneefall."),
    ],
  },

  {
    slug: "/streudienst-bremen",
    title: "Streudienst Bremen | Salz- und Streudienst für Wege & Flächen",
    description:
      "Streudienst in Bremen: Salz streuen, Sand und Granulat gegen Glätte auf Wegen, Zufahrten und Parkflächen. Glättebekämpfung für Privat und Gewerbe – Angebot auf Anfrage.",
    label: "/ Streudienst",
    service: "Streudienst Bremen",
    h1Lines: ["Streudienst Bremen –", "Glätte bekämpfen,", "bevor sie entsteht."],
    intro:
      "In Bremen ist nicht der große Schnee das Hauptproblem, sondern Glätte durch überfrierende Nässe. Unser Streudienst behandelt Gehwege, Zufahrten, Höfe und Parkflächen mit dem Streumittel, das zum Belag und zur Wetterlage passt.",
    image: IMG.plowStreet,
    sections: [
      {
        h2: "Glättebekämpfung in einem Seeklima",
        p: [
          "Bremen liegt im maritim geprägten Nordwesten. Das bedeutet: viele Tage um den Gefrierpunkt, hohe Luftfeuchte, Nebel, Nieselregen und Nachtfrost. Diese Kombination erzeugt eine Glätte, die oft kaum zu sehen ist – eine dünne, klare Eisschicht auf Pflaster, Beton und Asphalt. Sie ist gefährlicher als geschlossene Schneedecke, weil sie unterschätzt wird.",
          "Ein guter Streudienst reagiert deshalb nicht nur auf Schneefall, sondern auf die Wetterentwicklung. Wir beobachten Temperaturverlauf und Niederschlag und streuen dort, wo Glättebildung zu erwarten ist, möglichst bevor die Fläche genutzt wird.",
        ],
      },
      {
        h2: "Das Problem: falsches Streumittel, falsche Menge, falscher Ort",
        p: [
          "Streuen ist mehr als Salz verteilen. Zu viel Salz schädigt Pflaster, Beton, Metall und angrenzende Bepflanzung und ist auf vielen Flächen aus Umweltsicht nicht die erste Wahl. Zu wenig Streugut wirkt nicht. Abstumpfende Mittel wie Sand oder Granulat verbessern die Griffigkeit, lösen aber kein Eis – und müssen nach dem Winter wieder aufgenommen werden.",
          "Das dritte Problem ist die Fläche: Wer gleichmäßig alles bestreut, verschwendet Material. Entscheidend sind die kritischen Punkte: Stufen, Rampen, Gefälle, Kurven, Übergänge, Eingangsbereiche und Stellen, an denen Wasser stehen bleibt.",
        ],
      },
      {
        h2: "Die Lösung: flächengerechtes Streukonzept",
        p: [
          "Wir legen pro Objekt fest, welches Streumittel wo eingesetzt wird. Auf Fahrflächen und Rampen, bei denen es auf schnelle Wirkung ankommt, arbeiten wir auftauend. Auf empfindlichen Belägen und in Grünbereichen bevorzugen wir abstumpfende Mittel. Dosierung und Zeitpunkt richten sich nach Wetterlage und Nutzung.",
        ],
        bullets: [
          "Auftauende Streumittel auf Fahrflächen und Rampen",
          "Abstumpfende Mittel auf empfindlichen Belägen",
          "Gezielte Behandlung von Treppen, Gefällen und Eingängen",
          "Dosierung nach Wetterlage statt pauschal",
          "Nachstreuen bei anhaltender Glättegefahr",
          "Kombination mit Schneeräumung bei Neuschnee",
        ],
      },
      {
        h2: "Streudienst als Saisonleistung",
        p: [
          "Weil Glätte in Bremen häufiger auftritt als Schnee, ist der Streudienst der Teil des Winterdienstes, der am meisten Einsätze auslöst. Als Saisonleistung gebucht, entfällt für Sie das ständige Abwägen, ob heute Nacht gestreut werden muss. Wir übernehmen die Beurteilung und den Einsatz.",
        ],
      },
    ],
    steps: [
      { t: "Flächenanalyse", d: "Beläge, Gefälle, Entwässerung und kritische Punkte erfassen." },
      { t: "Streukonzept", d: "Festlegen, welches Mittel auf welcher Fläche eingesetzt wird." },
      { t: "Wetterbeobachtung", d: "Temperaturverlauf und Niederschlag im Blick behalten." },
      { t: "Streueinsatz", d: "Gezielt und dosiert streuen – bei Bedarf nachstreuen." },
    ],
    objects: [
      "Gehwege und Hauszugänge",
      "Treppen, Podeste und Rampen",
      "Einfahrten und Hofzufahrten",
      "Parkplätze und Parkdecks",
      "Betriebswege und Laderampen",
      "Zugänge zu Praxen und Läden",
    ],
    local:
      "Die Bremer Lage an Weser und Küste bringt feuchte, milde Luft – und damit viele Glättetage ohne nennenswerten Schnee. Besonders in Wassernähe, in den Niederungen und auf schattigen Nordseiten von Gebäuden hält sich Reif und Eis länger. Diese Stellen behandeln wir mit besonderer Aufmerksamkeit.",
    faq: [
      { q: "Verwenden Sie Streusalz?", a: "Ja, dort wo es sinnvoll und zulässig ist – vor allem auf Fahrflächen und Rampen. Auf empfindlichen Belägen und in Grünbereichen setzen wir bevorzugt Sand oder Granulat ein." },
      { q: "Wird auch gestreut, wenn kein Schnee liegt?", a: "Ja. Überfrierende Nässe und Reifglätte sind in Bremen der häufigere Fall und lösen eigene Streueinsätze aus." },
      { q: "Wie oft wird gestreut?", a: "So oft es die Wetterlage erfordert. Bei anhaltender Glättegefahr oder Regen auf gefrorenem Boden ist Nachstreuen notwendig." },
      { q: "Räumen Sie auch, oder nur streuen?", a: "Beides. Streudienst und Schneeräumung lassen sich einzeln oder kombiniert beauftragen." },
      { q: "Wird das Streugut im Frühjahr aufgenommen?", a: "Die Aufnahme abstumpfender Streumittel können wir auf Absprache mit anbieten." },
    ],
    related: [
      R("Eisbeseitigung Bremen", "/eisbeseitigung-bremen", "Festes Eis gezielt lösen."),
      R("Schneeräumung Bremen", "/schneeraeumung-bremen", "Erst räumen, dann streuen."),
      R("Treppen & Eingänge", "/treppen-winterdienst-bremen", "Die gefährlichsten Punkte."),
      R("Parkplätze", "/parkplatz-winterdienst-bremen", "Große Flächen streuen."),
      R("Winterdienst Gewerbe", "/winterdienst-bremen-gewerbe-hausverwaltung", "Verkehrssicherung für Betriebe."),
      R("Winterdienst Privat", "/winterdienst-bremen-privat", "Für Haus und Gehweg."),
    ],
  },
];
